import { Typography } from "@packages/ds";
import styled from "styled-components";

import { Link as DsLink, Button } from "ds/Button";

export const MainContainer = styled.div`
  margin-top: 24px;
`;

export const CompleteCodyText = styled(Typography.BodyText)`
  font-size: 14px;
`;

export const CopyWrapper = styled.div`
  margin: 24px 0 40px 0;
  code {
    white-space: nowrap;
    background-color: transparent;
    color: var(--section-snow-color, var(--snow));
  }
`;

export const CopyLabel = styled.div`
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--section-slate-color, var(--slate));
`;

export const ButtonModalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const Help = styled.p`
  margin: 16px 0 24px 0;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  svg {
    margin: 0 8px 0 0;
    vertical-align: middle;
  }
`;

export const Link = styled(DsLink)`
  text-transform: none;
`;

export const ConfirmationButton = styled(Button)`
  align-self: flex-end;
`;
